import React from 'react';
import styled from 'styled-components';

import Picture1 from '../../../containers/assets/instructor-onboarding-image22.png';
import Picture2 from '../../../containers/assets/instructor-onboarding-image23.png';
import Picture3 from '../../../containers/assets/instructor-onboarding-image24.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Images = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 12px;
`;

const HowWeSupportYou = () => (
  <Wrapper>
    <Container>
      <Text1>How We Support You</Text1>
      <Text2>Online &amp; Offline</Text2>
      <Text3>
        Throughout this exercise, we provide support to you and your students
        in a variety of ways. This includes, but not limited to, instant coaching
        feedback your students receive when they make an irrational decisions,
        our in-game chat and email support if there's any questions, and our
        personalized feedback/insights that you and your students receive at the end
        of each round and peer assessment.
      </Text3>

      <Images>
        <img src={Picture1} alt="" />
        <img src={Picture2} alt="" />
        <img src={Picture3} alt="" />
      </Images>

      <Text3>
        Let's walk through each round.
      </Text3>
    </Container>
  </Wrapper>
);

export default HowWeSupportYou;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/how-we-support-you.js